import React from 'react'
import { IEvent } from '../../store/events/interfaces'

export const EventAge = (props: {
  event: IEvent
  isFamilyRequired: boolean
}) => {
  const { event, isFamilyRequired } = props
  const minAge: number = event.min_age
  const maxAge: number = event.max_age
  const customAgeField: string | null = event.custom_age_field
  const noAgeLimitation = isFamilyRequired
    ? 'Altersempfehlung'
    : 'Altersbeschränkung'

  let result: string
  if (minAge && maxAge) {
    result = 'von ' + minAge + ' bis ' + maxAge + ' Jahre '
  } else if (minAge) {
    result = 'ab ' + minAge + ' Jahre '
  } else if (maxAge) {
    result = 'bis ' + maxAge + ' Jahre '
  } else if (customAgeField) {
    result = customAgeField
  } else {
    result = 'Keine ' + noAgeLimitation
  }

  return <>{result}</>
}
